import { useIsMobile } from "@/utils/animation";
import { AnimatePresence, motion } from "framer-motion";

interface NavLogoProps {
  homeURL: string;
  logoUrl: string;
  isVisible: boolean;
}

export const NavLogo = ({ homeURL, logoUrl, isVisible }: NavLogoProps) => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return isVisible ? (
      <a href={homeURL} className="relative block h-[30px] w-[102px]">
        <img
          alt="MavelPoint company"
          src={logoUrl}
          className="h-full w-full object-contain"
        />
      </a>
    ) : null;
  }

  return (
    <AnimatePresence mode="wait">
      {isVisible && (
        <motion.a
          href={homeURL}
          initial={{ opacity: 1, y: 0 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{
            duration: 0.15,
            ease: "easeOut",
          }}
          className="relative block h-[30px] w-[102px]"
        >
          <img
            alt="MavelPoint company"
            src={logoUrl}
            className="h-full w-full object-contain"
            decoding="async"
            loading="eager"
          />
        </motion.a>
      )}
    </AnimatePresence>
  );
};
